export const Z_INDEX_MODALS = {
  gdpr: {
    wp: 9000,
    react: 9000,
  },
  payment: {
    wp: 10_003, // We want this popup to be on top of the wp gdpr modal
    react: 10_003,
  },
  oneClickUpgrade: {
    modal: 10_000,
    success: 10_002,
  },
  onClickExtension: {
    wp: 10_003,
    react: 10_000,
  },
  authentication: {
    wp: 10_000,
    react: 10_000,
  },
  default: 10_000,
}
